<template>
  <div class='package_sizes_list'>
    <template v-for='size in sizeList'>
      <Tooltip
        :content="`o hasta ${formatThousands(size.alto, size.ancho, size.profundidad)} cm²`"
        position='top'
        :show="['XXS', 'XS', 'S', 'M', 'L', 'XL'].includes(size.codigo)"
      >
        <div class='package_size' :class="{ 'active': size.tallaId === sizeSelectedId }" @click='handleClick(size)'>

          <div v-if="size.estado && size.codigo !== 'P'" class='package_size--content'>

            <!-- Icon -->
            <Icon v-if="['SBR'].includes(size.codigo)" name='Document' :size='32' />
            <Icon v-if="['XXS'].includes(size.codigo)" name='Delivery-Box' :size='32' />
            <Icon v-if="['XS'].includes(size.codigo)" name='Delivery-Box' :size='32' />
            <Icon v-if="['S', 'M'].includes(size.codigo)" name='Delivery-Box-1' :size='32' />
            <Icon v-if="['L', 'XL', 'XXL'].includes(size.codigo)" name='Delivery-Box-2' :size='36' />

            <!-- Description -->
            <div v-if="size.codigo !== 'SBR'">
              <div class='text-xs-bold'>{{ size.alto }} x {{ size.ancho }} x {{ size.profundidad }} cm</div>
              <div class='text-xs-bold'>hasta {{ size.pesoMaximo }} kg</div>
              <div class='text-s-light'>{{ size.descripcion }}</div>
            </div>
            <div v-if="size.codigo === 'SBR'">
              <div class='text-xs-bold'>Documentos A4</div>
              <div class='text-s-light'>{{ size.descripcion }}</div>
            </div>

          </div>

          <div v-if="size.estado && size.codigo === 'P'" class='package_size--content'>
            <Icon name='Delivery-Box' variant='bulk' :size='32' />
            <div>
              <div class='text-xs-bold'>Hazlo único: suelta las cifras. 🛠️</div>
              <div class='text-s-light'>Personalizado</div>
            </div>
          </div>

        </div>
      </Tooltip>
    </template>
  </div>
</template>

<script>
import Icon from '@/components/Icon.vue'
import Tooltip from "@/components/Shared/Tooltip.vue";

export default {
  components: {
    Icon, Tooltip
  },
  props: {
    sizeSelectedId: { required: true },
    sizeList: { required: true, default: [] },
  },
  methods: {
    formatThousands(a, b, c) {
      const result = Number(a) * Number(b) * Number(c)
      return result.toLocaleString('en-US', { maximumFractionDigits: 0 })
    },
    handleClick(size) {
      this.$emit('input', size.tallaId)
      this.$emit('onSizeSelected', size)
    }
  },
}
</script>

<style lang='scss' scoped>
.package_sizes_list {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 16px;

  .package_size {
    cursor: pointer;

    padding: 24px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;

    box-shadow: 0 0 0 1px #D0D0D0;
    border-radius: 12px;

    transition: .2s;

    &:not(.active):hover {
      background-color: #D0D0D0;
      box-shadow: 0 0 0 1px #D0D0D0;
    }

    &.active {
      box-shadow: 0 0 0 1.5px #121212;
    }

    &--content {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      padding: 0 10px;
      gap: 5px;
    }
  }
}
</style>